<template>
    <div id="main">
        <div class="page">
            <div class="tipocadastrotalhao vertical-flow">
                <div class="listing-header">
                    <!-- TÍTULO E BREADCRUMB -->
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("tipo-cadastro-talhoes") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro-cadastros")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("tipo-cadastro-talhoes")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <!-- BOTÕES -->
                    <div class="header-buttons">
                        <button
                            v-if="!tipoTalhaIntegracao && permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({ name: 'agro-tipotalhao-new' })
                            "
                        >
                            {{ $t("adicionar") }}
                        </button>
                    </div>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="columns is-multiline">
                    <div class="column is-two-fifth">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                        />
                    </div>

                    <!-- PRODUTIVO -->
                    <div class="produtivo-select column is-one-fifth">
                        <label v-text="$t('produtivo')" />
                        <v-select
                            ref="produtivoInput"
                            class="is-100"
                            label="label"
                            :options="produtivos"
                            @input="updateProdutivo"
                            v-model="produtivo"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template
                                slot="selected-option"
                                slot-scope="option"
                            >
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{
                                $t("sem-resultados")
                            }}</template>
                        </v-select>
                    </div>
                    <!-- ARRENDADO -->
                    <div class="produtivo-select column is-one-fifth">
                        <label v-text="$t('arrendado')" />
                        <v-select
                            ref="arrendadoInput"
                            class="is-100"
                            label="label"
                            :options="arrendados"
                            @input="updateArrendado"
                            v-model="arrendado"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template
                                slot="selected-option"
                                slot-scope="option"
                            >
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{
                                $t("sem-resultados")
                            }}</template>
                        </v-select>
                    </div>

                    <!-- SITUACAO -->
                    <div class="situacao-select column is-one-fifth">
                        <label v-text="$t('situacao')" />
                        <v-select
                            ref="situacaoInput"
                            class="is-100"
                            label="label"
                            :options="situacoes"
                            @input="onSituacaoChanged"
                            v-model="situacao"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template
                                slot="selected-option"
                                slot-scope="option"
                            >
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{
                                $t("sem-resultados")
                            }}</template>
                        </v-select>
                    </div>
                </div>

                <!-- LISTAGEM -->
                <div class="tipocadastrotalhao-table registry-wrapper">
                    <container-loader
                        v-if="isLoading && !$store.getters.isLoading"
                    />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        class="data-table"
                        :data="alltipocadastrotalhoes"
                        :mobile-cards="false"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                                'label-km': f.key == 'label',
                            }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'codigo'">
                                <router-link
                                    :to="{
                                        name: 'agro-tipotalhao-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                            <div v-else-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: 'agro-tipotalhao-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                            <div v-else-if="f.key == 'produtivo'">
                                {{
                                    props.row.produtivo
                                        ? $t("sim")
                                        : $t("nao")
                                }}
                            </div>
                            <div v-else-if="f.key == 'arrendado'">
                                {{
                                    props.row.arrendado
                                        ? $t("sim")
                                        : $t("nao")
                                }}
                            </div>
                            <div v-else-if="!tipoTalhaIntegracao && f.key == 'excluir'">
                                <span v-if="permissao.update">
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1
                                                ? 'delete'
                                                : 'check'
                                        "
                                        @click="
                                            promptChangeSituacao(props.row)
                                        "
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </span>
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row[f.key] == 1"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t("ativo") }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t("inativo") }}</b-tag
                                >
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                </div>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import TipoCadastroTalhaoService from "@/services/TipoCadastroTalhaoService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            tipoTalhaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("TIPOTALHAO"),
            alltipocadastrotalhoes: [],
            service: new TipoCadastroTalhaoService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: null, sortable: true },
                { key: "descricao", width: null, sortable: true },
                { key: "produtivo", width: 80, sortable: true, centered: true },
                { key: "arrendado", width: 80, sortable: true, centered: true },
                { key: "situacao", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false },
            ],
            situacoes: [
                { label: "todos", id: 2 },
                { label: "ativo", id: 1 },
                { label: "inativo", id: 0 },
            ],
            situacao: { label: "todos", id: 2 },
            produtivos: [
                { label: "todos", id: 2 },
                { label: "produtivo", id: 1 },
                { label: "improdutivo", id: 0 },
            ],
            produtivo: { label: "todos", id: 2 },
            arrendados: [
                // filtro para verificar se o talhão é prórpio ou arrendado
                { label: "todos", id: 2 },
                { label: "arrendado", id: 1 },
                { label: "proprio", id: 0 },
            ],
            arrendado: { label: "todos", id: 2 },
            isLoading: false,
            isEmpty: false,
            column: "descricao",
            order: "asc",
            debouncedOnSearch: null,
            situacaoAcao: null,
            deleteThis: null,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-cadastros",
            "agro-tipotalhao"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-tipotalhao" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            let params = [
                //filtro para filtrar o produtivo e arrendado
                !this.isNull(this.queryFilter) ? this.queryFilter : ".*",
                this.isNull(this.produtivo) ? 2 : this.produtivo.id,
                this.isNull(this.arrendado) ? 2 : this.arrendado.id,
            ];

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.alltipocadastrotalhoes = value;
                    this.isEmpty = this.alltipocadastrotalhoes.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = this.alltipocadastrotalhoes.length <= 0;
                    console.error("Ocorreu algum erro: ", { e });
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            if (body && body.content) {
                this.pagination.totalRows = body.totalElements;
                let tipocadastrotalhaolist = body.content.map((mf) => {
                    return {
                        id: mf.idtipocadastrotalhao,
                        codigo: mf.idtipocadastrotalhaoerp,
                        descricao: mf.descricao,
                        produtivo: mf.produtivo,
                        arrendado: mf.arrendado,
                        situacao: mf.situacao,
                    };
                });
                return tipocadastrotalhaolist;
            } else {
                return [];
            }
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-agro-tipotalhao"
                    : "msg-erro-ao-reativar-agro-tipotalhao";

            let tempTipoTalhao = {
                idtipocadastrotalhao: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;

            this.service
                .updateSituacao(tempTipoTalhao)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-agro-tipotalhao"
                                : "msg-sucesso-ao-desativar-agro-tipotalhao";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },

        updateProdutivo(t) {
            this.produtivo = t
                ? this.produtivos.filter((v) => v.id == t.id)[0]
                : this.produtivos[0];
            this.carregarDados();
        },
        updateArrendado(t) {
            this.arrendado = t
                ? this.arrendados.filter((v) => v.id == t.id)[0]
                : this.arrendados[0];
            this.carregarDados();
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
}

.page {
    position: relative;
    padding-left: 0;

    .situacao-select div,
    .produtivo-select div {
        height: 40px;
    }
}
</style>
